import {Template, Component} from '@scoutgg/ftw/source/lib'
import template from './create-new-user.jade'
import notify from '@scoutgg/ftw/source/services/notification'
import '../status'
import { User } from '../../models'

@Component('sporty')
@Template(template)
export default class CreateNewUser extends HTMLElement {
  attached() {
    this.user = null
  }

  closeModal() {
    this.parentNode.close()
  }

  async createUser() {
    const hostElement = document.querySelector('sporty-create-new-user');
    const shadowRoot = hostElement.shadowRoot;
    const form = shadowRoot.querySelector('form');

    if(!form.checkValidity()) {
      return form.reportValidity()
    }

    try {
      const attrs = [
        'email',
        'username',
        'role',
      ]
      const params = {}
      for(const attr of attrs) {
        const value = form.querySelector(`[name=${attr}]`).value
        if(!value) throw new Error(`Missing value for "${attr}"`)
        params[attr] = value
      }
      const response = await User.post(params)
      this.user = response.user
      this.password = response.password
      this.render()

    } catch(err) {
      notify(err.message, {
        level: 'danger',
        timeout: 10000,
      })
    }
  }
}
